import { Header } from '@scuf/common';
import { OSSAgreementContainer, Content, OSSContent } from './oss-agreement-content.styles';
import { BodyWrapper } from 'Containers/AppFrame.styles';
import ErrorComponent from 'Components/ErrorEvent';

export const OSSAgreementContent = ({
  ossContent = '',
  error = '',
  t = l => l,
}) => {
  return (
    <OSSAgreementContainer>
      {/* Inline styles used here to keep the majority of BodyWrapper including themes, but fit to modal */}
      <BodyWrapper style={{ height: '100%', width: '100%', maxHeight: '100%', overflow: 'hidden' }}>
        <Header title={t('OSS')} menu={false} collapseAt={700} />
        <Content>
          {error ? (
            <ErrorComponent>{error}</ErrorComponent>
          ) : (
            <OSSContent>
              {ossContent}
            </OSSContent>
          )}
        </Content>
      </BodyWrapper>
    </OSSAgreementContainer>
  );
};

export default (props) => <OSSAgreementContent {...props} />;
